<template>
    <div>
        <div class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.user_bank_account_detail') }}
            </div>
            <form id="bank_account_detail">
                <kt-row>
                    <kt-col lg="3" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="bank_id">
                                {{ $t('pos.bank') }}
                            </kt-form-label>
                            <select
                                    id="bank_id"
                                    name="bank_id"
                                    v-model="request_details.bank_account_detail.bank_id"
                                    class="form-control kt-selectpicker-edit-bank-acc"
                            >
                                <option
                                        v-for="bank in constants.banks"
                                        v-bind:key="bank.BankID"
                                        :value="bank.BankID">
                                    {{ bank.BankName }}
                                </option>
                            </select>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="branch_code">
                                {{ $t('pos.branch_code') }}
                            </kt-form-label>
                            <kt-form-control
                                    type="number"
                                    dir="ltr"
                                    id="branch_code"
                                    name="branch_code"
                                    v-model="request_details.bank_account_detail.branch_code"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="account_number">
                                {{ $t('label.account_number') }}
                            </kt-form-label>
                            <kt-form-control
                                    id="account_number"
                                    name="account_number"
                                    dir="ltr"
                                    v-model="request_details.bank_account_detail.account_number"
                                    class="form-control"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col lg="3" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="sheba_number">
                                {{ $t('label.sheba_number') }}
                            </kt-form-label>
                            <kt-form-label for="sheba_number">
                                <div class="btn btn-sm btn-clean btn-icon btn-icon-sm special-tooltip">
                                    <span class="tooltip-text">{{ $t('pos.btn_inquiry') }}</span>
                                    <i @click="ibanInquiry" class="fa fa-sync"
                                       style="font-size: 14px;color: #1dc9b7; "></i>
                                </div>
                            </kt-form-label>
                            <kt-form-control
                                    style="direction: ltr;"
                                    id="sheba_number"
                                    name="sheba_number"
                                    v-model="request_details.bank_account_detail.sheba_number"
                                    class="form-control transfers_destination_number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                    <kt-col style="padding-top: 35px" lg="4" md="4" xs="12">
                        <kt-form-group>

                            <div class="custom-control custom-switch">
                                <input type="checkbox" class="custom-control-input" id="has_stakeholder"
                                       name="has_stakeholder"
                                       v-model="request_details.bank_account_detail.has_stakeholder"
                                >
                                <label class="custom-control-label"
                                       for="has_stakeholder">{{ $t('pos.stakeholders') }}</label>
                            </div>
                        </kt-form-group>
                    </kt-col>
                    <!--                    <kt-col style="padding-top: 35px" lg="4" md="6" xs="12">-->
                    <!--                        <kt-form-group>-->

                    <!--                            <div class="custom-control custom-switch">-->
                    <!--                                <input type="checkbox" class="custom-control-input" id="is_multi_account_owner"-->
                    <!--                                       name="is_multi_account_owner"-->
                    <!--                                       v-model="request_details.bank_account_detail.is_multi_account_owner"-->
                    <!--                                >-->
                    <!--                                <label class="custom-control-label"-->
                    <!--                                       for="is_multi_account_owner">{{ $t('pos.is_multi_account_owner') }}</label>-->
                    <!--                            </div>-->
                    <!--                        </kt-form-group>-->
                    <!--                    </kt-col>-->
                    <kt-col v-show="request_details.bank_account_detail.has_stakeholder" lg="3" md="6" xs="12">
                        <kt-form-group>
                            <kt-form-label for="main_sharing_percent">
                                {{ $t('pos.main_sharing_percent') }}
                            </kt-form-label>
                            <kt-form-control
                                    style="direction: ltr"
                                    type="number"
                                    id="main_sharing_percent"
                                    name="main_sharing_percent"
                                    v-model="request_details.bank_account_detail.main_sharing_percent"
                                    class="form-control transfers_destination_number"
                            ></kt-form-control>
                        </kt-form-group>
                    </kt-col>
                </kt-row>
            </form>
            <kt-row v-if="wizard.operation == 'edit' && request_details.status == posStatuses.ACTIVE">
                <kt-col lg="4" md="4" xs="4">
                    <kt-form-action style=" direction: ltr; display: inline;">
                        <kt-button
                                class="m-2"
                                size="md"
                                @click="changeSheba"
                                variant="success"
                                type="submit"
                                v-bind:wide="true"
                                id="change_sheba"
                        >
                            {{ $t('pos.change_sheba') }}
                        </kt-button>
                    </kt-form-action>
                </kt-col>
            </kt-row>
        </div>

        <div v-show="request_details.bank_account_detail.has_stakeholder"
             class="container p-3 pt-5 my-4 border in-border-header">
            <div class="section-header">
                {{ $t('pos.stakeholders') }}
            </div>
            <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
        </div>
        <multi-account v-if="multi_accounts" :request_details="request_details" :multi_accounts="multi_accounts"
                       :reloadDataTable="reloadDataTable"
                       v-show="request_details.bank_account_detail.has_stakeholder"
                       style="margin-bottom: 100px">

        </multi-account>

        <!--        <multi-account-owner :request_details="request_details"-->
        <!--                       v-show="request_details.bank_account_detail.is_multi_account_owner"-->
        <!--                       style="margin-bottom: 100px">-->

        <!--        </multi-account-owner>-->
        <kt-row>
            <kt-col lg="4" md="4" xs="4">
                <kt-form-action style=" direction: ltr; display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="step_back"
                            variant="danger"
                            type="submit"
                            v-bind:wide="true"
                            id="step_back"
                    >
                        {{ $t('label.step_back') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
            <kt-col lg="6" md="6" xs="4"></kt-col>
            <kt-col lg="2" md="2" xs="4">
                <kt-form-action style=" display: inline;">
                    <kt-button
                            class="m-2"
                            size="md"
                            @click="next_step"
                            variant="success"
                            type="submit"
                            v-bind:wide="true"
                            id="next_step"
                    >
                        {{ $t('label.next_step') }}
                    </kt-button>
                </kt-form-action>
            </kt-col>
        </kt-row>
        <kt-col lg="2" md="2" xs="4">
            <kt-form-action style=" display: none;">
                <kt-button
                        data-toggle="modal" data-target="#iban_inquiry"
                        variant="success"
                        type="submit"
                        id="iban_inquiry_fire"
                >
                </kt-button>
            </kt-form-action>
        </kt-col>
        <kt-col lg="2" md="2" xs="4">
            <kt-form-action style=" display: none;">
                <kt-button
                        data-toggle="modal" data-target="#iban_inquiry"
                        variant="success"
                        type="submit"
                        id="iban_inquiry_fire"
                >
                </kt-button>
            </kt-form-action>
        </kt-col>
        <div id="iban_inquiry" class="modal fade rtl" role="dialog">
            <div class="modal-dialog">

                <!-- Modal content-->
                <div class="modal-content">
                    <div class="modal-header">
                        <div id="iban_inquiry_title">{{ $t('pos.iban_inquiry_title') }}</div>
                        <div v-if="iban_inquiry.status == false" style=" padding-right: 20%" id="iban_inquiry_incorrect">
                            <span style="background-color:#fd397a"> {{
                                    $t('pos.message.iban_inquiry_incorrect')
                                }}</span></div>
                        <div v-if="iban_inquiry.status == true" style=" padding-right: 20%" id="iban_inquiry_correct">
                            <span style="background-color:#1dc9b7">   {{
                                    $t('pos.message.iban_inquiry_correct')
                                }}</span></div>
                        <button type="button" class="close float-right mr-0" data-dismiss="modal">&times;</button>
                    </div>
                    <div id="data_sheet" class="modal-body mb-4">
                        <table class="table table-hover">
                            <thead>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.account_owner_fullname')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.account_owner_name }}</th>
                            </tr>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.bank')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.bank }}</th>
                            </tr>
                            <tr>
                                <th class="table-info" colspan="2">{{ $t('pos.customer_code')+' :' }}</th>
                                <th class="table-info" colspan="2">{{ iban_inquiry.identifier }}</th>
                            </tr>
                            </thead>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery'
import {i18n} from '@/plugins/i18n'
import {posService} from '@/common/api.service';
import Inputmask from "inputmask";
import MultiAccount from "./multi-account";
import MultiAccountColumns from "../visitor/datatable/Multi_Account";
import ActionsMultiAccountColumn from "./actions-multi-account";
import toastr from "toastr";
import {ApiUrl} from "../../../../common/api.service";
import {AuthorizationHeader} from "../../../../common/jwt.service";
import {KTApp} from '@/plugins/core/app';
import {mapGetters} from "vuex";
import {customerType} from '@/constants/posNovin'
import {posStatuses} from '@/constants/PosStatus'
import IranSheba from "iran-sheba";


export default {
    components: {MultiAccount},
    data() {
        return {
            bank_account_detail: [],
            multi_accounts: [],
            customerType,
            posStatuses,
            iban_inquiry:{}
        }
    },
    props: {
        wizard: {
            type: Object
        },
        request_details: {
            type: Object
        },
    },
    watch: {
        wizard: {
            handler(newValue, oldValue) {
                if (newValue.newCustomer == true) {
                    this.reloadDataTable()
                    this.wizard.newCustomer = false
                }
            },
            deep: true
        },
        datatable_status: {
            handler(newValue, oldValue) {
                if (newValue == 'new_data') {
                    this.reloadDataTable()
                    this.$store.commit('pos/setDatatableStatus', null)
                }
            },
        },
    },
    methods: {
        next_step() {
            if (this.request_details.bank_account_detail.has_stakeholder) {
                this.multi_accounts = this.$refs.datatable.KTDatatable.originalDataSet
                if (this.multi_accounts.length < 1) return this.toastr.error(i18n.t('pos.stakeholders_minimum'))
            }
            let form = $('#bank_account_detail')
            let btn = $('#next_step')
            form.validate({
                lang: 'fa',
                rules: {
                    bank_id: {
                        required: ()=>{
                            if (this.psp == 'NOVIN') return true;
                        }
                    },

                    branch_code: {
                        required: true,
                    },
                    account_number: {
                        required: true
                    },

                    sheba_number: {
                        required: true,
                    },

                    main_sharing_percent: {
                        required: () => {
                            if (this.request_details.bank_account_detail.has_stakeholder) return true; else return false
                        }
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            let sheba = this.request_details.bank_account_detail.sheba_number
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')
            this.request_details.bank_account_detail.sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            var sum_percents = 0
            if (this.request_details.bank_account_detail.has_stakeholder) {
                for (let i = this.multi_accounts.length - 1; i >= 0; i--) {
                    sum_percents = parseInt(sum_percents) + parseInt(structuredClone(this.multi_accounts[i]['sharing_percent']))
                }
                if (parseInt(sum_percents) + parseInt(structuredClone(this.request_details.bank_account_detail.main_sharing_percent)) != 100) return this.toastr.error(i18n.t('pos.sum_percents'))
            }
            this.wizard.current_step = 3;
        },
        step_back() {
            this.wizard.current_step = 1;
        },
        initShebaMask() {
            Inputmask("IR 9999-9999-9999-9999-9999-9999").mask(document.querySelectorAll('.transfers_destination_number'));
        },
        afterDispatch() {
            setTimeout(() => {
                $('.kt-selectpicker-edit-bank-acc').selectpicker({
                    size: 6,
                    liveSearch: true,
                    noneResultsText: i18n.t('selectpicker.none_result'),
                    selectAllText: i18n.t('selectpicker.select_all'),
                    noneSelectedText: i18n.t('selectpicker.nothing_chose')
                });
            }, 500);
        },
        reloadDataTable() {
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
                setTimeout(() => {
                    this.multi_accounts = this.$refs.datatable.KTDatatable.originalDataSet
                }, 6000);
            }
        },
        ibanInquiry() {
            let sheba = this.request_details.bank_account_detail.sheba_number
            sheba = sheba.split('-').join('')
            sheba = sheba.split(' ').join('')
            sheba = sheba.split('_').join('')
            this.request_details.bank_account_detail.sheba_number = sheba
            if (sheba.length != 26) return this.toastr.error(i18n.t('pos.message.invalid_sheba_format'))

            let params = {
                identifier: this.request_details.customer_detail.customer_type_id == customerType.REAL ?
                        this.request_details.customer_detail.national_code : this.request_details.customer_detail.company_code,
                sheba_number: this.request_details.bank_account_detail.sheba_number
            }
            posService.ibanInquiry(params).then(response => {
                this.iban_inquiry = {
                    status : response.data.data.status,
                    account_owner_name : this.request_details.customer_detail.first_name_fa +' '+
                            this.form_data.request_details.last_name_fa,
                    identifier : params.identifier,
                    bank : IranSheba.recognize(params.sheba_number)['persianName']
                }
                document.getElementById("iban_inquiry_fire").click();
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            })
        },
        changeSheba() {
            let form = $('#bank_account_detail')
            let btn = $('#change_sheba')
            form.validate({
                lang: 'fa',
                rules: {
                    bank_id: {
                        required: true
                    },

                    branch_code: {
                        required: true,
                    },
                    account_number: {
                        required: true
                    },

                    sheba_number: {
                        required: true,
                    },

                    main_sharing_percent: {
                        required: () => {
                            if (this.request_details.bank_account_detail.has_stakeholder) return true; else return false
                        }
                    },
                }
            });
            if (!form.valid()) {
                return
            }
            KTApp.progress(btn)

            let params = {
                bank_id: this.request_details.bank_account_detail.bank_id,
                branch_code: this.request_details.bank_account_detail.branch_code,
                account_number: this.request_details.bank_account_detail.account_number,
                sheba_number: this.request_details.bank_account_detail.sheba_number,
                main_sharing_percent: this.request_details.bank_account_detail.main_sharing_percent,
                pos_merchant_id: this.request_details.pos_merchant_id,
            }
            posService.changeSheba(params).then(response => {
                return this.toastr.success(response.data.message)
            }).catch(({response}) => {
                return this.toastr.error(response.data.message)
            });

            KTApp.unprogress(btn)
        }
    },
    mounted() {
        setTimeout(() => {
            if (this.$refs.datatable.KTDatatable) {
                this.multi_accounts = this.$refs.datatable.KTDatatable.originalDataSet
            }
        }, 6000);
        this.afterDispatch()
        this.initShebaMask()
    },
    computed: {
        datatableProps() {
            return {
                id: "edit_multi_account_datatable",
                data: {
                    type: "remote",
                    source: {
                        read: {
                            url: ApiUrl.path(`pos/get-pos-request-stakeholders/${this.request_details.id}`),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: function (res) {
                                return res.data
                            },
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                sortable: true,
                columns: MultiAccountColumns,
                actions: ActionsMultiAccountColumn,
            };
        },
        toastr() {
            toastr.options = {
                closeButton: true,
                positionClass: "toast-bottom-center",
                preventDuplicates: false,
                rtl: false
            }
            return toastr
        },
        ...mapGetters('pos', [
            'constants', 'psp', 'datatable_status'
        ])
    },
}
</script>
<style>
.kt-form-label {
    text-align: right !important;
}

.special-tooltip {
    position: relative;
    display: inline-block;
}

.special-tooltip .tooltip-text {
    visibility: hidden;
    background-color: #555;
    color: #fff;
    text-align: center;
    padding: 5px 10px;
    border-radius: 6px;
    position: absolute;
    z-index: 1;
    bottom: 125%;
    opacity: 0;
    transition: opacity 0.3s;
    min-width: 60px !important;
}

.special-tooltip .tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    /*margin-left: -5px;*/
    border-width: 5px;
    border-style: solid;
    border-color: #555 transparent transparent transparent;
}

.special-tooltip:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}
</style>